/** Browser storage is optional; denied storage must not invalidate a live memory session. */
export const safeLocalStorage = {
    getItem(key: string): string | null {
        try {
            return window.localStorage.getItem(key);
        } catch {
            return null;
        }
    },
    setItem(key: string, value: string): void {
        try {
            window.localStorage.setItem(key, value);
        } catch {
            /* Memory remains authoritative. */
        }
    },
    removeItem(key: string): void {
        try {
            window.localStorage.removeItem(key);
        } catch {
            /* Storage may be unavailable. */
        }
    },
};
